import { createContext, useContext, useState } from "react";

export const translations = {
  fr: {
    nav: { cta: "Rejoindre la waitlist" },
    hero: {
      badge: "Lancement imminent — Accès prioritaire",
      kicker: "Analyse · Stats · Stratégie",
      trust: "✓ Gratuit, sans carte  ✓ Accès prioritaire au lancement",
      lines: ["Vois les opportunités", "avant tout le monde."],
      subtitle:
        "HitMax génère des pronostics foot, tennis et basket par intelligence artificielle. Précis, data-driven, disponible avant que l'instant décisif n'arrive.",
      formLabel: "Accès gratuit & prioritaire au lancement",
      firstName: "Prénom",
      lastName: "Nom",
      email: "Email",
      submit: "Je réserve ma place",
      submitting: "Réservation…",
      success: "Place réservée. Bienvenue dans le clan HitMax.",
      already: "Cet email est déjà sur la liste.",
      referralTitle: "Ton lien de parrainage",
      referralText: "Chaque ami inscrit avec ton lien te fait gagner des places dans la file.",
      copy: "Copier",
      copied: "Copié !",
      share: "Partager",
      shareText: "Je viens de réserver ma place sur HitMax — pronostics foot par IA. Rejoins la waitlist avec mon lien :",
      vipTitle: "Surclassement VIP — 30 jours",
      vipText: "30 jours de VIP au prix du tarif de base. Réservé aux inscrits, valable au lancement.",
      vipButton: "Passer VIP — 6,99 €",
      vipOldPrice: "29,99 €",
      vipRedirect: "Redirection vers le paiement…",
      demoBadge: "Démo live",
      error: "Une erreur est survenue. Réessaie.",
      invalid: "Vérifie les champs saisis.",
      counterSuffix: "personnes ont déjà réservé leur place",
    },
    countdown: {
      label: "Lancement officiel dans",
      days: "jours",
      hours: "heures",
      mins: "min",
      secs: "sec",
    },
    payment: {
      checking: "Vérification du paiement…",
      paid: "Paiement confirmé. Ton VIP est activé.",
      paidSub: "30 jours de VIP t'attendent au lancement, le 24 septembre.",
      failed: "Paiement non confirmé. Réessaie ou contacte-nous.",
      cancelTitle: "Paiement annulé",
      cancelSub: "Aucun débit. Ta place sur la waitlist reste réservée.",
      home: "Retour à l'accueil",
    },
    marquee: ["PRÉCISION", "DATA-DRIVEN", "CLASSEMENT ELO", "DISTRIBUTION DE POISSON", "ZÉRO ÉMOTION", "QUE DES MATHS", "EXPECTED GOALS"],
    how: {
      kicker: "Le parcours",
      title: "Du match au verdict. En quatre temps.",
      steps: [
        { title: "Ouvre HitMax, choisis ton match", desc: "Ligue 1, Premier League, Ligue des Champions : les matchs du jour et tes championnats suivis, à une seule tape." },
        { title: "Le moteur scanne le match", desc: "Elo, forme récente, expected goals, historique des confrontations : plus de 40 signaux digérés en quelques secondes." },
        { title: "Reçois le verdict", desc: "Un pronostic net, une cote, un niveau de confiance — et une analyse courte que tu lis en dix secondes." },
        { title: "Suis la précision, jour après jour", desc: "Chaque verdict est archivé. La performance du moteur reste visible et vérifiable, match après match." },
      ],
      mock2: { elo: "Elo", form: "Forme", h2h: "Confrontations" },
      mock4: { title: "Derniers pronostics", win: "Gagné", loss: "Perdu", accuracy: "Précision sur 30 jours" },
    },
    demo: {
      kicker: "Le moteur IA",
      title: "Regarde l'IA réfléchir. En direct.",
      match: "Arsenal vs Manchester City — Premier League",
      run: "Lancer l'analyse",
      rerun: "Relancer",
      running: "Analyse en cours…",
      confidence: "Indice de confiance",
      factors: "Facteurs analysés",
      tags: ["Forme : V-V-N-V-V", "xG : 1.9 vs 1.2", "H2H : 3V sur 5", "Elo : +42", "Poisson : 52 %"],
      analysis:
        "Analyse terminée — Arsenal vs Manchester City.\nArsenal affiche 4 victoires sur ses 5 derniers matchs avec un xG moyen de 1.9 à domicile. City reste dangereux en transition mais concède 1.4 xGA à l'extérieur. Le modèle de Poisson projette : victoire Arsenal 52 %, nul 26 %, victoire City 22 %. Historique des confrontations : léger avantage Arsenal (3 victoires sur 5).\nVerdict HitMax : avantage Arsenal — confiance élevée.",
      placeholder: "En attente du lancement de l'analyse…",
    },
    video: {
      kicker: "HitMax en action",
      title: "La prédiction, en mouvement.",
      desc: "Regarde une prédiction se construire de bout en bout : le scan des données, l'analyse rédigée en direct, puis le verdict.",
      beats: [
        { title: "Le scan", desc: "Le moteur digère plus de 40 signaux : Elo, forme, xG, historique." },
        { title: "L'analyse", desc: "L'IA rédige son raisonnement en direct, sous tes yeux." },
        { title: "Le verdict", desc: "Un pronostic net, une cote, un indice de confiance mesuré." },
      ],
      liveLink: "Rejouer l'expérience en direct",
      cta: "Je réserve ma place",
    },
    benefits: {
      kicker: "Pourquoi HitMax",
      title: "Pas un feeling. Une science.",
      cards: [
        { title: "La data, pas le feeling", desc: "Classement Elo, expected goals, distribution de Poisson : chaque pronostic est un calcul, jamais une intuition." },
        { title: "Multi-sports à venir", desc: "Le football d'abord. Le tennis et le basket rejoignent HitMax juste après le lancement.", tag: "Bientôt" },
        { title: "Transparence totale", desc: "Chaque pronostic est archivé et l'historique des performances est public. Les chiffres parlent, pas nous." },
        { title: "Pensée pour le quotidien", desc: "Une interface premium, rapide et claire. Ton pronostic du jour en dix secondes, chaque matin." },
      ],
    },
    samurai: {
      kicker: "L'esprit samouraï",
      title: "La précision du geste. La discipline de la donnée.",
      body: "Comme le samouraï qui ne frappe qu'à l'instant exact, HitMax n'émet un pronostic que lorsque les données sont parfaitement alignées. Patience. Précision. Sang-froid.",
      principles: ["Patience", "Précision", "Sang-froid"],
    },
    today: {
      label: "Le match du jour",
      confidence: "confiance",
      cta: "Analyser en direct",
      odds: "cote",
    },
    essai: {
      kicker: "L'essai — exactement comme dans l'app",
      title: "L'analyse complète, en conditions réelles.",
      desc: "Voici ce que le moteur HitMax produit sur un vrai match. Aucun texte d'exemple : ce sont les données réelles du moteur.",
      scoreLabel: "HitMax Score",
      confidence: "Confiance élevée",
      verdictLabel: "Verdict du moteur",
      oddsLabel: "Cote",
      likely: "Score probable",
      analysisTitle: "L'analyse du moteur",
      cta: "Je réserve ma place",
    },
    demoPage: {
      back: "Retour à l'accueil",
      replay: "Relancer l'analyse",
      idle: "Choisis ton match et lance le moteur — l'IA génère le pronostic en direct.",
      unavailable: "Le moteur HitMax se réveille… Réessaie dans un instant.",
      realData: "Données réelles — moteur HitMax",
      scoreProbable: "Score probable",
      analysesToday: "analyses générées aujourd'hui",
      cta: "Je réserve ma place",
    },
    footer: {
      cta: "Réserve ta place avant le coup d'envoi.",
      button: "Je réserve ma place",
      legal: "© 2026 HitMax. Tous droits réservés.",
      disclaimer: "HitMax est un outil d'analyse statistique. Aucune promesse de gain. Jouez de manière responsable.",
    },
  },
  en: {
    nav: { cta: "Join the waitlist" },
    hero: {
      badge: "Launching soon — Priority access",
      kicker: "Analysis · Stats · Strategy",
      trust: "✓ Free, no card  ✓ Priority access at launch",
      lines: ["See opportunities", "before everyone else."],
      subtitle:
        "HitMax generates AI-powered football, tennis and basketball predictions. Precise, data-driven, delivered before the decisive moment happens.",
      formLabel: "Free & priority access at launch",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      submit: "Reserve my spot",
      submitting: "Reserving…",
      success: "Spot reserved. Welcome to the HitMax clan.",
      already: "This email is already on the list.",
      referralTitle: "Your referral link",
      referralText: "Every friend who joins with your link moves you up the queue.",
      copy: "Copy",
      copied: "Copied!",
      share: "Share",
      shareText: "I just reserved my spot on HitMax — AI football predictions. Join the waitlist with my link:",
      vipTitle: "VIP upgrade — 30 days",
      vipText: "30 days of VIP at the base plan price. Members only, valid at launch.",
      vipButton: "Go VIP — €6.99",
      vipOldPrice: "€29.99",
      vipRedirect: "Redirecting to checkout…",
      demoBadge: "Live demo",
      error: "Something went wrong. Try again.",
      invalid: "Please check the fields.",
      counterSuffix: "people have already reserved their spot",
    },
    countdown: {
      label: "Official launch in",
      days: "days",
      hours: "hours",
      mins: "min",
      secs: "sec",
    },
    payment: {
      checking: "Checking your payment…",
      paid: "Payment confirmed. Your VIP is activated.",
      paidSub: "30 days of VIP await you at launch, on September 24.",
      failed: "Payment not confirmed. Try again or contact us.",
      cancelTitle: "Payment cancelled",
      cancelSub: "No charge. Your waitlist spot stays reserved.",
      home: "Back to home",
    },
    marquee: ["PRECISION", "DATA-DRIVEN", "ELO RATINGS", "POISSON DISTRIBUTION", "NO EMOTION", "JUST MATH", "EXPECTED GOALS"],
    how: {
      kicker: "The journey",
      title: "From match to verdict. In four beats.",
      steps: [
        { title: "Open HitMax, pick your match", desc: "Premier League, LaLiga, Champions League: today's fixtures and your followed leagues, one tap away." },
        { title: "The engine scans the match", desc: "Elo, recent form, expected goals, head-to-head history: 40+ signals digested in seconds." },
        { title: "Get the verdict", desc: "A clear prediction, the odds, a confidence level — and a short analysis you read in ten seconds." },
        { title: "Track accuracy, day after day", desc: "Every verdict is archived. The engine's performance stays visible and verifiable, match after match." },
      ],
      mock2: { elo: "Elo", form: "Form", h2h: "Head-to-head" },
      mock4: { title: "Latest predictions", win: "Won", loss: "Lost", accuracy: "30-day accuracy" },
    },
    demo: {
      kicker: "The AI engine",
      title: "Watch the AI think. Live.",
      match: "Arsenal vs Manchester City — Premier League",
      run: "Run analysis",
      rerun: "Run again",
      running: "Analysing…",
      confidence: "Confidence score",
      factors: "Factors analysed",
      tags: ["Form: W-W-D-W-W", "xG: 1.9 vs 1.2", "H2H: 3W in 5", "Elo: +42", "Poisson: 52%"],
      analysis:
        "Analysis complete — Arsenal vs Manchester City.\nArsenal have won 4 of their last 5 matches with an average xG of 1.9 at home. City remain dangerous in transition but concede 1.4 xGA away. The Poisson model projects: Arsenal win 52%, draw 26%, City win 22%. Head-to-head history: slight Arsenal edge (3 wins in 5).\nHitMax verdict: Arsenal advantage — high confidence.",
      placeholder: "Waiting for the analysis to run…",
    },
    video: {
      kicker: "HitMax in action",
      title: "The prediction, in motion.",
      desc: "Watch a prediction being built end to end: the data scan, the analysis written live, then the verdict.",
      beats: [
        { title: "The scan", desc: "The engine digests 40+ signals: Elo, form, xG, history." },
        { title: "The analysis", desc: "The AI writes its reasoning live, right before your eyes." },
        { title: "The verdict", desc: "A clear prediction, the odds, a measured confidence score." },
      ],
      liveLink: "Replay the live experience",
      cta: "Reserve my spot",
    },
    benefits: {
      kicker: "Why HitMax",
      title: "Not a gut feeling. A science.",
      cards: [
        { title: "Data, not feelings", desc: "Elo ratings, expected goals, Poisson distribution: every prediction is a calculation, never a hunch." },
        { title: "Multi-sport coming", desc: "Football first. Tennis and basketball join HitMax right after launch.", tag: "Soon" },
        { title: "Full transparency", desc: "Every prediction is archived and the performance history is public. The numbers speak, not us." },
        { title: "Built for daily use", desc: "A premium, fast and clear interface. Your prediction of the day in ten seconds, every morning." },
      ],
    },
    samurai: {
      kicker: "The samurai spirit",
      title: "The precision of the strike. The discipline of data.",
      body: "Like the samurai who strikes only at the exact moment, HitMax issues a prediction only when the data is perfectly aligned. Patience. Precision. Composure.",
      principles: ["Patience", "Precision", "Composure"],
    },
    today: {
      label: "Match of the day",
      confidence: "confidence",
      cta: "Analyse it live",
      odds: "odds",
    },
    essai: {
      kicker: "The trial — exactly like in the app",
      title: "The complete analysis, in real conditions.",
      desc: "This is what the HitMax engine produces on a real match. No sample text: this is the engine's real data.",
      scoreLabel: "HitMax Score",
      confidence: "High confidence",
      verdictLabel: "Engine verdict",
      oddsLabel: "Odds",
      likely: "Likely score",
      analysisTitle: "The engine's analysis",
      cta: "Reserve my spot",
    },
    demoPage: {
      back: "Back to home",
      replay: "Run the analysis again",
      idle: "Pick your match and run the engine — the AI generates the prediction live.",
      unavailable: "The HitMax engine is waking up… Try again in a moment.",
      realData: "Real data — HitMax engine",
      scoreProbable: "Likely score",
      analysesToday: "analyses generated today",
      cta: "Reserve my spot",
    },
    footer: {
      cta: "Reserve your spot before kick-off.",
      button: "Reserve my spot",
      legal: "© 2026 HitMax. All rights reserved.",
      disclaimer: "HitMax is a statistical analysis tool. No promise of winnings. Play responsibly.",
    },
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("fr");
  const t = translations[lang];
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);

const FR_DAYS = ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."];
const FR_MONTHS = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];

export const formatKickoff = (kickoff, lang = "fr") => {
  if (!kickoff) return "";
  const [datePart, timePart] = kickoff.split("·").map((s) => s.trim());
  const d = new Date(`${datePart}T${timePart || "00:00"}:00`);
  if (isNaN(d)) return kickoff;
  if (lang === "fr") {
    return `${FR_DAYS[d.getDay()]} ${d.getDate()} ${FR_MONTHS[d.getMonth()]} · ${timePart.replace(":", "h")}`;
  }
  return `${d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" })} · ${timePart}`;
};
